export const COUPON_PERCENTAGE = 'Percentage';
export const COUPON_FIXED_AMOUNT = 'Fixed Amount';
